import React from 'react';

import {
  errorUtil,
  fields
} from 'iron-forge-react-modules';

import { useForm } from 'react-hook-form';
import { BaseTier1ReturnAuthorizationModal } from 'modules/layer01';
import { appValidationUtil } from 'modules/layer00';
import * as dataService from './dataService';
import * as types from './types';



const ControlledTextField = fields.TextField.genControllerComponent<types.IFormState>();


export interface IProps {
  returnAuthorizationId: string;
  onClose: () => void;
  onFinish: () => void;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.returnAuthorizationId);
  const [
    receiveTier1ReturnAuthorization,
    receiveTier1ReturnAuthorizationTuple
  ] = dataService.useReceiveTier1ReturnAuthorization(props.returnAuthorizationId);
  const form = useForm<types.IFormState>({
    defaultValues: {
      serialNumber: ''
    }
  });

  const processSubmit = React.useCallback(
    async (formState: types.IFormState) => {
      const { expectedSerialNumber } = queryTuple.data;
      const serialNumbersDoNotMatch = expectedSerialNumber !== formState.serialNumber;
      if (expectedSerialNumber && serialNumbersDoNotMatch) {
        if (!window.confirm("That number does not match the expected serial number for this return. Do you want to continue?")) {
          return;
        }
      }

      if (!expectedSerialNumber && !window.confirm("This return does not have an IMEI. Are you sure you want to use this value in the receipt?")) {
        return;
      }

      await errorUtil.errorWrap(async () => {
        if (window.confirm("Are you sure you want to receive this item?")) {
          await receiveTier1ReturnAuthorization(formState, queryTuple.data.itemId);
          props.onFinish();
        }
      }, {
        ITEM_RECEIPT_EXISTS: "An item receipt already exists for this return."
      });
    },
    [
      props,
      queryTuple.data,
      receiveTier1ReturnAuthorization
    ]
  );

  const loading = queryTuple.loading || receiveTier1ReturnAuthorizationTuple.loading;

  return (
    <BaseTier1ReturnAuthorizationModal.FC
      title="Receive Item"
      primaryText="Enter IMEI"
      secondaryText="Enter an IMEI to find the correct RMA"
      onClose={props.onClose}
      onSubmit={form.handleSubmit(processSubmit)}>
      <ControlledTextField
        isRequired
        isDisabled={loading}
        label="IMEI"
        fieldKey="serialNumber"
        formControl={form.control}
        extraValidationRules={{ pattern: appValidationUtil.reImei }} />
    </BaseTier1ReturnAuthorizationModal.FC>
  );
};
